export default __webpack_public_path__ + "static/kokall-zomer-mobiel-2-0a984f79d5c207fe41426222c9742f14.png";